module.exports = __webpack_public_path__ + "static/media/cutscene-1.8bb0e1c8.mp4";